module.exports = __webpack_public_path__ + "RedefineExMobile.png";


//////////////////
// WEBPACK FOOTER
// ./theme/bananar/assets/RedefineExcellence2023/RedefineExMobile.png
// module id = 180
// module chunks = 0 1